// External libraries
import { isString } from '@checkout/react-components';

// Internal modules
import { useOnMount } from './useOnMount';
import { $logger } from '../logger';

const COMPONENT_NAME_REGEX = /([a-z])([A-Z])/g;

const mapNameToSnakeCase = str => {
  return isString(str)
    ? str.replace(COMPONENT_NAME_REGEX, '$1_$2').toLowerCase()
    : '';
};

const useMountLogging = componentName => {
  const component = mapNameToSnakeCase(componentName);

  useOnMount(() => {
    $logger.info(`weasley_${component}_component_mounted`);
    return () => {
      $logger.info(`weasley_${component}_component_unmounted`);
    };
  });
};

export { useMountLogging };
